import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  Badge,
} from "reactstrap";
import Breadcrumb from "../common/breadcrumb";
import { useSelector } from "react-redux";
import Loader from "../../shared/Loader";
import { errorToast } from "../../shared/Toast";
import {
  fetchAllAboutUsValues,
  updateAboutUsValue,
} from "../../utils/apiCalls";

const AboutUsValues = () => {
  const [aboutUsValues, setAboutUsValues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingAboutUs, setEditingAboutUs] = useState(null);
  const [formData, setFormData] = useState({ title: "", arabicTitle: "", description: "", arabicDescription: "" });

  const userType = localStorage.getItem("userType");
  const storedMerchantId = localStorage.getItem("MerchantId");
  const { selectedMerchant: reduxSelectedMerchant } = useSelector((state) => state.merchant || {});
  const selectedMerchant = userType === "merchant" ? storedMerchantId : reduxSelectedMerchant;

  const fetchAboutUsValues = async () => {
    if (!selectedMerchant || selectedMerchant === "all") return;
    setLoading(true);
    try {
      const data = await fetchAllAboutUsValues(selectedMerchant);
      setAboutUsValues(data || []);
    } catch (error) {
      console.error("Error fetching About Us Values:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAboutUsValues();
  }, [selectedMerchant]);

  const openEditModal = (aboutUs) => {
    setEditingAboutUs(aboutUs);
    setFormData({
      title: aboutUs.title || "",
      arabicTitle: aboutUs.arabicTitle || "",
      description: aboutUs.description || "",
      arabicDescription: aboutUs.arabicDescription || "",
    });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setFormData({ title: "", arabicTitle: "", description: "", arabicDescription: "" });
  };

  const handleSubmit = async () => {
    if (!formData.title) {
      errorToast("Title is required.");
      return;
    }

    if (!formData.description) {
      errorToast("Description is required.");
      return;
    }

    if (!selectedMerchant || selectedMerchant === "all") {
      errorToast("Please select a merchant first.");
      return;
    }

    
    const result = await updateAboutUsValue(editingAboutUs.id, formData);
    if (result) {
      closeModal();
      fetchAboutUsValues();
    }
  };

  return (
    <Fragment>
      <Breadcrumb title="About Us Values" parent="" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5>About Us Values</h5>                
              </CardHeader>
              <CardBody>
                {loading ? (
                  <Loader />
                ) : !selectedMerchant || selectedMerchant === "all" ? (
                  <div className="text-center text-muted py-4">
                    Please select a merchant to view About Us values.
                  </div>
                ) : aboutUsValues.length === 0 ? (
                  <div className="text-center text-muted py-4">
                    No About Us Values found. Create one to get started.
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table className="table-border-horizontal">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Title</th>
                          <th>Arabic Title</th>
                          <th>Description</th>
                          <th>Arabic Description</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {aboutUsValues.map((aboutUs, index) => (
                          <tr key={aboutUs.id}>
                            <td>{index + 1}</td>
                            <td>                              
                                {aboutUs.title}
                            </td>
                            <td style={{ direction: "rtl" }}>{aboutUs.arabicTitle || "-"}</td>
                            <td>{aboutUs.description}</td>
                            <td style={{ direction: "rtl" }}>{aboutUs.arabicDescription || "-"}</td>                            
                            <td>
                              <Button
                                color="info"
                                size="sm"
                                className="me-2"
                                onClick={() => openEditModal(aboutUs)}
                              >
                                Edit
                              </Button>                              
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={modalOpen} toggle={closeModal}>
          <ModalHeader toggle={closeModal}>
            Edit About Us Value
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Title:</Label>
              <Input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                placeholder="Enter Title"
              />
            </FormGroup>
            
            <FormGroup>
              <Label>Arabic Title:</Label>
              <Input
                type="text"
                value={formData.arabicTitle}
                onChange={(e) => setFormData({ ...formData, arabicTitle: e.target.value })}
                placeholder="Enter Arabic Title"
              />
            </FormGroup>

            <FormGroup>
              <Label>Description:</Label>
              <Input
                type="text"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                placeholder="Enter Description"
              />
            </FormGroup>

            <FormGroup>
              <Label>Arabic Description:</Label>
              <Input
                type="text"
                value={formData.arabicDescription}
                onChange={(e) => setFormData({ ...formData, arabicDescription: e.target.value })}
                placeholder="Enter Arabic Description"
              />
            </FormGroup>

          </ModalBody>
          <ModalFooter>
            <Button
              style={{
                backgroundColor: "#dc3545",
                borderColor: "#dc3545",
                borderRadius: "4px",
                padding: "8px 20px",
                fontSize: "14px",
              }}
              onClick={handleSubmit}
            >
              Update
            </Button>
            <Button
              style={{
                backgroundColor: "#6c757d",
                borderColor: "#6c757d",
                borderRadius: "4px",
                padding: "8px 20px",
                fontSize: "14px",
              }}
              onClick={closeModal}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </Fragment>
  );
};

export default AboutUsValues;
